// Logto配置
import { ReservedResource, UserScope } from '@logto/react';

// API 资源标识符
export const API_RESOURCE = 'https://magicpage.cflpai.com';

// 业务 scope（权限范围）
export const APP_SCOPE = 'magicpage:access';

// 组织权限列表（非API权限）
export const ORGANIZATION_PERMISSIONS = [
  'delete:data',
  'delete:member',
  'invite:member',
  'manage:member',
  'read:data',
  'view:logs',
  'write:data',
];

export const logtoConfig = {
  endpoint: 'https://logto.cflpai.com/',
  appId: 'fu7kt79y7k8bthegqq2az',
  // 配置资源和权限范围
  resources: [
    ReservedResource.Organization,  // 组织资源
    API_RESOURCE,                    // 业务API资源
  ],
  scopes: [
    UserScope.Organizations,         // 用户组织范围
    APP_SCOPE,                       // 业务API scope
    ...ORGANIZATION_PERMISSIONS,     // 组织权限scopes（非API），让组织Token返回权限
  ],
};

// 根据当前环境判断重定向URI
// 自动适配 localhost、IP 地址、域名等所有访问方式
const getRedirectUri = () => {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // 调试输出
  console.log('🔍 Logto配置调试:');
  console.log('  Origin:', origin);
  console.log('  Hostname:', hostname);
  console.log('  Port:', port || '(默认)');
  
  // 直接使用当前的 origin + /callback
  // 支持 localhost、IP 地址、域名等所有访问方式
  const redirectUri = `${origin}/callback`;
  console.log('  使用重定向URI:', redirectUri);
  return redirectUri;
};

const getPostLogoutRedirectUri = () => {
  const origin = window.location.origin;
  // 直接使用当前的 origin
  return origin;
};

export const redirectUri = getRedirectUri();
export const postLogoutRedirectUri = getPostLogoutRedirectUri();

// 在控制台输出配置信息（方便调试）
console.log('📋 Logto 重定向URI配置:');
console.log('  重定向URI:', redirectUri);
console.log('  退出登录后重定向URI:', postLogoutRedirectUri);
console.log('  ⚠️  请在Logto控制台配置以上URI！');
console.log('  Logto控制台: https://logto.cflpai.com/');
